import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row" }
const _hoisted_2 = { class: "px-6 py-3 flex flex-col h-full justify-center text-center space-y-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-black-lp-300 text-12px"
}
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = {
  key: 1,
  class: "w-full flex justify-center"
}
const _hoisted_7 = { class: "flex flex-col rounded-lg w-full rounded-tr-lg border border-aqua-lp-400\n      " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TooltipV2, {
        text: _ctx.translateTitle(_ctx.data?.title),
        fontSize: 16,
        fontWeight: "bold",
        description: _ctx.$t(_ctx.data?.description || ''),
        class: "whitespace-nowrap"
      }, null, 8, ["text", "description"]),
      (!_ctx.loading && _ctx.isShowTotal)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("p", null, _toDisplayString(_ctx.$t("dashboard.console.common.total")) + " :", 1),
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.formatPriceWithoutCurrency(_ctx.data.totalStt)) + " STT ", 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Icons, {
          name: _ctx.data.icon,
          class: "text-aqua-lp-300 h-16",
          status: _ctx.data.iconStatus
        }, null, 8, ["name", "status"])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_Spinner, {
              class: "loader",
              style: {"height":"45px"},
              color: "#EBECF0"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.sttData, (item, index) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: index,
          loading: _ctx.loading,
          title: _ctx.translateTitle(item?.title),
          "border-color": "border-aqua-lp-400",
          totalStt: item.totalStt,
          startDate: item.start,
          endDate: item.end,
          data: item,
          border: `${index !== 0 ? 'border-t' : ''}`,
          rounded: 
            `${index === 0 ? 'rounded-t-xl' : ''} ${
              index === _ctx.data.length - 1 ? 'rounded-b-lg' : ''
            }`
          ,
          styleTimer: `${index === 0 ? 'rounded-tr-lg' : ''}`
        }, null, 8, ["loading", "title", "totalStt", "startDate", "endDate", "data", "border", "rounded", "styleTimer"]))
      }), 128))
    ])
  ]))
}